<template>
  <canvas ref="sankeyChart" />
</template>

<script>
import { defineComponent, onMounted } from "vue";
import { Chart as ChartJS, Title, Tooltip, Legend, LinearScale } from "chart.js";
import { SankeyController, Flow } from "chartjs-chart-sankey";
import { overviewSankeyGraphData } from "@/constants/monetization-fake-data";

ChartJS.register(Title, Tooltip, Legend, SankeyController, Flow, LinearScale);

export default defineComponent({
  name: "OverviewSankeyGraph",
  setup() {
    onMounted(() => {

      const colors = {
        gross_revenue: "#89c0ff",
        subscription_revenue: "#63aafb",
        digital_product_revenue: "#63aafb",
        affiliate_revenue: "#63aafb",
        sponsored_content_revenue: "#63aafb",
        syndication_revenue: "#63aafb",
        display_ads_revenue: "#63aafb",
        inspiration_fees: "#ffdf97",
        collaborator_expenses: "#ef7575",
        net_revenue: "#b0ed7a",
      };

      const getColor = key => colors[key];

      const ctx = document.querySelector("canvas").getContext("2d");
      new ChartJS(ctx, {
        type: "sankey",
        data: {
          datasets: [
            {
              data: overviewSankeyGraphData,
              colorFrom: item => getColor(item.dataset.data[item.dataIndex].from),
              colorTo: item => getColor(item.dataset.data[item.dataIndex].to),
              colorMode: "to",
              alpha: 1,
              labels: {
                gross_revenue: "Gross Revenue",
                inspiration_fees: "Inspiration Fees",
                collaborator_expenses: "Collaborator Expenses",
                net_revenue: "Net Revenue",
                subscription_revenue: "Subscription",
                digital_product_revenue: "Digital Product",
                affiliate_revenue: "Affiliate",
                syndication_revenue: "Syndication",
                sponsored_content_revenue: "Sponsored Content",
                display_ads_revenue: "Display Ads",
              },
              size: "min",
            },
          ],
        },
        options: {
          // nodeWidth: 10,
          // nodePadding: 30,
          responsive: true,
          maintainAspectRatio: true,
        },
      });
    });
  },
});
</script>

<style scoped>
canvas {
  width: 100%;
  height: 400px;
}
</style>
